module.exports = __webpack_public_path__ + "img/cpgl.1f8e98e6.png";